<template>
    <div
      class="selection-box"
      @click="checkActions"
      :class="{'active': checked.regBuzNo == merchant.regBuzNo}"
    >
      <div class="left">
        <div class="top">
          <span>{{ merchant.merGrpId }}</span>
          <span>{{ merchant.merGrpNm }}</span>
        </div>
        <div class="bottom">
          <p>사업자번호
            <span>{{ merchant.regBuzNo | formatRegBuzNo }}</span>
          </p>
        </div>
      </div>
      <div class="right">
        <div class="img">
          <img
            :src="checked.regBuzNo != merchant.regBuzNo ?
            require('@/assets/images/etc-etc-checkbox.svg') : require('@/assets/images/etc-etc-checkbox-dn.svg')"/>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'SelectionBox',
  props: ['merchant', 'checked'],
  data: function () {
    return {
      provider: 'cfa',
      merchantGroups: [],
      isDialogOpen: false,
    }
  },
  methods: {
    checkActions() {
      this.checked.regBuzNo = this.merchant.regBuzNo
      this.checked.merGrpNm = this.merchant.merGrpNm
    }
  }
}
</script>

<style lang="scss" scoped>
  .selection-box {
    width: 100%;
    height: 78px;
    border-radius: 4px;
    box-shadow: 0 8px 18px 0 rgba(32, 35, 36, 0.08);
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 16px;
    font-weight: 800;
    &.active {
      border: solid 1px #1baaf1;
    }
    .left {
      .top {
        margin-bottom: 5px;
        span {
          font-size: 13px;
          font-weight: normal;
          letter-spacing: -0.3px;
          color: #727d8c;
          &:last-child {
            margin-left: 6px;
          }
        }
      }
      .bottom p {
        font-size: 16px;
        letter-spacing: 0.4px;
      }
    }
    .right {
      margin-left: auto;
    }
  }
</style>
